import React, { Component } from 'react'

class ClinicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clinicName: '',
      contactName: '',
      email: '',
      numClinics: '',
      numVets: '',
      location: '',
      message: '',
      submitted: false,
      loading: false,
      error: '',
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { clinicName, contactName, email, numClinics, numVets, location } = this.state;
    if (!clinicName || !email || !numVets || !location) {
      this.setState({ error: 'Merci de remplir les champs obligatoires.' });
      return;
    }

    this.setState({ loading: true, error: '' });

    try {
      await fetch('https://lama.fetchy.vet/api/newsletter/contact/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: `[CLINIQUE] ${clinicName} — ${contactName}`,
          email: email,
          message: `Demande clinique / école :
Clinique : ${clinicName}
Contact : ${contactName}
Email : ${email}
Nombre de cliniques : ${numClinics || 'Non renseigné'}
Nombre de vétérinaires : ${numVets}
Localisation : ${location}
Message : ${this.state.message || '—'}`,
        }),
      });
      this.setState({ submitted: true });
    } catch (err) {
      this.setState({ error: 'Une erreur est survenue. Réessaie plus tard.' });
    }
    this.setState({ loading: false });
  }

  render() {
    const { clinicName, contactName, email, numClinics, numVets, location, message, submitted, loading, error } = this.state;

    return (
      <div>
        <div className="tc" style={{ marginBottom: 24 }}>
          <span className="eyebrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            Cliniques & Écoles
          </span>
          <h2 style={{ marginTop: 8, fontSize: 'clamp(1.5rem, 1.2rem + 2vw, 2rem)' }}>Un plan adapté à votre structure.</h2>
          <p className="muted" style={{ margin: '0 auto', maxWidth: '46ch', fontSize: 15 }}>
            Comptes multiples, facturation centralisée, onboarding accompagné.
          </p>
        </div>

        {submitted ? (
          <div className="stu-success">
            <div className="stu-success__ic">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <h2>Demande reçue !</h2>
            <p>On revient vers vous très vite avec une proposition adaptée.</p>
          </div>
        ) : (
          <form className="stuform" onSubmit={this.handleSubmit}>
            <div className="sturow sturow--2">
              <div>
                <label className="field-lbl">Nom de la structure *</label>
                <input className="field" name="clinicName" value={clinicName} onChange={this.handleChange} placeholder="Clinique, école, groupe..." required />
              </div>
              <div>
                <label className="field-lbl">Personne de contact</label>
                <input className="field" name="contactName" value={contactName} onChange={this.handleChange} placeholder="Prénom Nom" />
              </div>
            </div>

            <div>
              <label className="field-lbl">Email *</label>
              <input className="field" type="email" name="email" value={email} onChange={this.handleChange} placeholder="contact@clinique.fr" required />
            </div>

            <div className="sturow sturow--2">
              <div>
                <label className="field-lbl">Nombre de cliniques</label>
                <select className="field" name="numClinics" value={numClinics} onChange={this.handleChange}>
                  <option value="">—</option>
                  <option value="1">1</option>
                  <option value="2-5">2 à 5</option>
                  <option value="6-20">6 à 20</option>
                  <option value="20+">Plus de 20</option>
                </select>
              </div>
              <div>
                <label className="field-lbl">Nombre de vétérinaires *</label>
                <select className="field" name="numVets" value={numVets} onChange={this.handleChange} required>
                  <option value="">—</option>
                  <option value="1-3">1 à 3</option>
                  <option value="4-10">4 à 10</option>
                  <option value="11-30">11 à 30</option>
                  <option value="30+">Plus de 30</option>
                </select>
              </div>
            </div>

            <div>
              <label className="field-lbl">Localisation *</label>
              <input className="field" name="location" value={location} onChange={this.handleChange} placeholder="Ville, département ou pays" required />
            </div>

            <div>
              <label className="field-lbl">Message (optionnel)</label>
              <textarea className="field" name="message" rows="3" value={message} onChange={this.handleChange} placeholder="Besoins particuliers, calendrier..."></textarea>
            </div>

            {error && (
              <p style={{ color: 'var(--coral-600)', fontSize: 14, margin: 0 }}>{error}</p>
            )}

            <button
              type="submit"
              className="vt-btn vt-btn-call vt-btn-lg w100"
              disabled={loading}
            >
              {loading ? 'Envoi...' : 'Demander un devis'}
            </button>
          </form>
        )}
      </div>
    )
  }
}

export default ClinicForm
